/** 로그인 없이 열리는 화면(`P-01`~`P-04`)의 주소. **이 네 줄이 유일한 자리다.**
 *
 * 결제사(토스페이먼츠) 계약 심사에 내는 URL 의 일부다. `P-01` 은 「결제 상품 · 서비스 확인
 * URL」, `P-02` 는 「환불정책 확인 URL」이다(PRD `7.0` 「로그인 전 화면」). 목업은 경로를
 * `[환불정책 경로]` 처럼 자리 표시로 두었고, 이 회차가 짧고 흔한 영문 경로로 정했다.
 *
 * ⛔ **한 번 심사에 낸 뒤로는 바꾸지 않는다.** 바꾸면 결제사에 낸 주소가 없는 화면을 가리킨다.
 * 라우트(`App.tsx`) · 사업자 정보의 링크(`components/BusinessInfo.tsx`) · 화면 안의 링크가 모두
 * 여기서 읽는다. 문자열을 다시 적지 않는다. */
export const PUBLIC_PATHS = {
  /** `P-01` 서비스 안내. */
  service: "/",
  /** `P-02` 환불정책. */
  refund: "/refund",
  /** `P-03` 이용약관. */
  terms: "/terms",
  /** `P-04` 개인정보처리방침. */
  privacy: "/privacy",
} as const;

/** `P-04` 의 바뀐 뒤 판(PRD `7.5.17` `P-04b` 의 `바뀐 뒤 전문 ›`). 심사에 낸 네 주소와 다른 줄에 둔다.
 *  ⚠️ 개정 값 `PENDING_POLICY_AMENDMENT.nextPath` 와 같은 글자여야 한다(`scripts` 시험이 잰다). */
export const PRIVACY_NEXT_PATH = "/privacy/next";

/** 로그인 화면(`W-01`). 공개 화면의 머리 줄 `로그인` 과 `P-01` 의 `시작하기` 가 여기로 간다. */
export const LOGIN_PATH = "/login";
